import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const steps = [
  'type', 'animal', 'color', 'personality', 'accessories', 'names', 'summary'
];

const options = {
  type: ['Human', 'Animal', 'Robot'],
  animal: [
    '🐵','🐶','🦁','🐸','🐼','🐨','🐯','🦊','🐷','🐮','🐔','🐧','🐦','🐤','🐣','🦆','🦉','🦅','🦇','🐺','🦄','🐝','🦋','🐛','🐌','🐞','🐜','🦂','🐢','🐍','🦕','🦖','🐙','🦑','🦐','🦞','🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🐘','🦣','🦛','🦏','🐫','🐪','🦙','🦒','🦬','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦌','🐐','🦃','🐓','🦚','🦜','🦢','🦩','🕊️','🐇','🦝','🦡','🦨','🦦','🦥','🐁','🐀','🐿️','🦔'
  ],
  color: [
    { name: 'Pink', hex: '#FFC0CB' },
    { name: 'Red', hex: '#FF0000' },
    { name: 'Orange', hex: '#FFA500' },
    { name: 'Yellow', hex: '#FFFF00' },
    { name: 'Green', hex: '#008000' },
    { name: 'Blue', hex: '#0000FF' },
    { name: 'Purple', hex: '#800080' },
    { name: 'White', hex: '#FFFFFF' },
    { name: 'Black', hex: '#000000' },
    { name: 'Gray', hex: '#808080' },
    { name: 'Brown', hex: '#A52A2A' },
    { name: 'Turquoise', hex: '#40E0D0' }
  ],
  personality: ['Funny', 'Shy', 'Brave', 'Mysterious', 'Wild', 'Smart', 'Kind', 'Grumpy', 'Curious', 'Energetic'],
  accessories: [
    '🧢','🎒','👟','🧤','🕶️','⛑️','🎩','🎀','🪖','🧳','👝','👛','👜','💼','🎮','📱','📸','🎧','🎯','⚽','🏀','🏈','🎲','🪀','🧸','🥽','🩴','🥾','👒','👑','🪅','🪡','🧵','🧶','🧲','🪞','🎓','💍','🎗️','🧿','🪬','🎒','🛍️','📦','🎁','💼','🪃','🪁','🎠','🎡','🎢','🛹','🛷','⛸️','🛼','🚲','🛴','🦽','🦼','🛺','🗿','🧩','🪀','🪁','🥁','🎺','🎷','🪗','🎸','🎻','🪘','🎤','🎙️','📻','📺','📽️','🎞️','📷','📹','🧮','🔭','🔬','🕹️','🖲️','🧱','🧲','🧯','🛎️','🔑','🗝️','💡','🔦','🕯️','🧭','🧰','🪚','🔧','🔨','🪛'
  ]
};

const nameSuggestions1 = [
  'Zontra','Plixie','Brimbo','Kroosh','Nubbit','Sniffy','Twixly','Jorba','Flinka','Zibby','Wigzo','Mokku','Tubbly','Drizza','Groffy','Lompa','Kizzu','Frilly','Gloob','Bazzit','Spunka','Dizzly','Maffy','Torpo','Vlibby','Paffy','Quonky','Zaffi','Hokku','Treeko','Zuppy','Snorzo','Niffy','Crimbo','Fazzy','Droppa','Twuffy','Vimzo','Plompo','Glommy'
];

const nameSuggestions2 = [
  'Lex','Hex','Vex','Dax','Rax','Tix','Laz','Fex','Zyn','Kix','Jex','Mux','Nex','Bex','Gix','Pox','Zex','Vix','Lux','Qix','Dex','Rex','Sax','Tux','Wex','Yax','Zox','Box','Cex','Fox','Gex','Hux','Jix','Kex','Lix','Max','Nox','Oxz','Pix','Qux'
];

export default function CreateNubbi() {
  const [stepIndex, setStepIndex] = useState(0);
  const [formData, setFormData] = useState({ animal: [], color: [], accessories: [] });
  const [customName, setCustomName] = useState('');
  const [email, setEmail] = useState('');
  const [instagram, setInstagram] = useState('');
  const currentStep = steps[stepIndex];

  const toggleSelect = (key, value, max = 1) => {
    let current = formData[key] || [];
    const isSelected = current.includes(value);
    if (isSelected) current = current.filter(v => v !== value);
    else if (current.length < max) current.push(value);
    setFormData({ ...formData, [key]: current });
  };

  const handleSingle = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleNext = () => {
    if (currentStep === 'animal' && formData.animal.length < 1) return alert('Choose at least 1 animal');
    if (currentStep === 'names' && !customName.trim()) return alert('Please write a name');
    setStepIndex(stepIndex + 1);
  };

  const submitForm = async () => {
    const name = customName;
    const selectedColors = formData.color.map(c => c.name).join(', ');
    const summary = `NAME: ${name}\nTYPE: ${formData.type}\nANIMALS: ${formData.animal.join(' ')}\nCOLORS: ${selectedColors}\nPERSONALITY: ${formData.personality}\nACCESSORIES: ${formData.accessories.join(' ')}\nEMAIL: ${email}\nINSTAGRAM: ${instagram}`;
    const { error } = await supabase.from('creative_requests').insert([{ summary }]);
    if (!error) alert('Your Nubbi was submitted!');
    else alert('Submission failed.');
  };

  const isSelected = (key, value) => {
    return Array.isArray(formData[key]) ? formData[key].includes(value) : formData[key] === value;
  };

  const renderSuggestions = (names) => (
    <div className="option-grid">
      {names.map((name) => (
        <div key={name} className="suggestion-box">{name}</div>
      ))}
    </div>
  );

  const renderOptions = (key, items, max = 1, style = {}) => (
    <div className="option-grid">
      {items.map((item) => (
        <button
          key={item.name || item}
          onClick={() => max === 1 ? handleSingle(key, item) : toggleSelect(key, item, max)}
          className={`option-btn ${isSelected(key, item) ? 'selected' : ''}`}
          style={item.hex ? { backgroundColor: item.hex, ...style } : style}
        >
          {!item.hex ? item : ''}
        </button>
      ))}
    </div>
  );

  const renderStep = () => {
    switch (currentStep) {
      case 'type':
        return <>{renderOptions('type', options.type)}</>;
      case 'animal':
        return <><p>Select 1 to 3 animals</p>{renderOptions('animal', options.animal, 3)}</>;
      case 'color':
        return <><p>Select up to 3 colors</p>{renderOptions('color', options.color, 3, { width: 60, height: 60, borderRadius: '50%' })}</>;
      case 'personality':
        return <><p>Choose a personality</p>{renderOptions('personality', options.personality)}</>;
      case 'accessories':
        return <><p>Select up to 3 accessories (optional)</p>{renderOptions('accessories', options.accessories, 3)}</>;
      case 'names':
        return (
          <>
            <p>Need inspiration? Here are some ideas:</p>
            {renderSuggestions(nameSuggestions1)}
            {renderSuggestions(nameSuggestions2)}
            <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>✏️ Select your name:<br /><span style={{ fontWeight: 'normal' }}>You can get inspired by the names above or invent your own below</span></p>
            <input
              type="text"
              value={customName}
              onChange={(e) => setCustomName(e.target.value)}
              placeholder="Write your Nubbi's name here"
              className="input-box highlight"
            />
          </>
        );
      case 'summary':
        return (
          <>
            <h3>📝 Your Nubbi Summary</h3>
            <p><strong>NAME:</strong> {customName}</p>
            <p><strong>TYPE:</strong> {formData.type}</p>
            <p><strong>ANIMALS:</strong> {formData.animal.join(' ')}</p>
            <p><strong>COLORS:</strong> {formData.color.map(c => c.name).join(', ')}</p>
            <p><strong>PERSONALITY:</strong> {formData.personality}</p>
            <p><strong>ACCESSORIES:</strong> {formData.accessories.join(' ')}</p>
            <input type="email" placeholder="Email (optional)" value={email} onChange={(e) => setEmail(e.target.value)} className="input-box" />
            <input type="text" placeholder="Instagram (optional)" value={instagram} onChange={(e) => setInstagram(e.target.value)} className="input-box" />
            <button className="submit-btn" onClick={submitForm}>Submit</button>
          </>
        );
    }
  };

  return (
    <div className="form-wrapper">
      <h2>Create Your Nubbi</h2>
      {renderStep()}
      {stepIndex < steps.length - 1 && (
        <button className="next-btn" onClick={handleNext}>Next</button>
      )}
      <style>{`
        .form-wrapper {
          text-align: center;
          padding: 2rem;
          background: #fff4f4;
          border-radius: 20px;
          max-width: 600px;
          margin: auto;
          font-family: 'Comic Sans MS', cursive;
        }
        .option-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin: 1rem 0;
        }
        .option-btn {
          font-size: 1.8rem;
          padding: 1rem 1.5rem;
          border: 3px solid #ddd;
          border-radius: 15px;
          background-color: #fff;
          transition: all 0.2s;
          cursor: pointer;
        }
        .option-btn:hover {
          background-color: #f5f5f5;
        }
        .option-btn.selected {
          background-color: #ffe066 !important;
          border-color: #ffae00;
          transform: scale(1.1);
        }
        .suggestion-box {
          font-size: 1rem;
          padding: 0.6rem 1rem;
          border: 2px solid #ccc;
          border-radius: 12px;
          background-color: #fff;
        }
        .highlight {
          border: 3px solid #ffae00;
          font-weight: bold;
        }
        .input-box {
          display: block;
          margin: 1rem auto;
          padding: 0.6rem;
          font-size: 1.2rem;
          border-radius: 10px;
          border: 2px solid #ccc;
          width: 80%;
        }
        .next-btn, .submit-btn {
          margin-top: 1rem;
          font-size: 1.2rem;
          padding: 0.8rem 2rem;
          border: none;
          border-radius: 12px;
          background-color: #66d3fa;
          color: white;
          cursor: pointer;
        }
        .next-btn:hover, .submit-btn:hover {
          background-color: #3ab0dd;
        }
      `}</style>
    </div>
  );
}